import React from 'react'

export default function LayoutsSignIn(props) {
  return (
    <section><a className="anchor" id="signin"></a>
      <div className="push--bottom grid">
          <div className="grid__col-sm-12  grid__col-lg-6">
              <a href="samples/signin.html"><img src="images/signin.png" alt="Screenshot of the sign in snippet" className="media__img"/></a>
          </div>
          <div className="media__body soft--top grid__col-sm-12  grid__col-lg-6">
            <h2>Sign in snippet</h2>
            Example of using -
            <ul>
              <li><a href={props.staticVersion === true ? '#core/forms' : 'Core#forms'}>Forms</a></li>
              <li><a href={props.staticVersion === true ? '#core/buttons' : 'Core#buttons'}>Buttons</a></li>
              <li><a href={props.staticVersion === true ? '#core/panels' : 'Core#panels'}>Panels</a></li>
            </ul>
            <p><a className="btn" href="samples/signin.html">View live preview</a>&nbsp;<a className="btn" href="samples/signin.html" download>Download</a></p>
          </div>
      </div>
    </section>
  )
}



// WEBPACK FOOTER //
// ./styleguide/components/sections/LayoutsSignIn.js